import { defineMessages } from 'react-intl';

export const workspaceMessages = defineMessages({
  header: { id: 'app.sml.workspaces.header', defaultMessage: 'Workspaces' },
  count: { id: 'app.sml.workspaces.count', defaultMessage: '{count}' },
  yourWorkspace: { id: 'app.sml.workspaces.yourWorkspace', defaultMessage: 'Your workspace' },
  planArtists: {
    id: 'app.sml.workspaces.planArtists',
    defaultMessage: '{plan} · {count, plural, one {# artist} other {# artists}}',
  },
  opening: { id: 'app.sml.workspaces.opening', defaultMessage: 'Opening…' },
  switchFailed: { id: 'app.sml.workspaces.switchFailed', defaultMessage: 'We could not open {workspace}.' },
  noLongerMember: {
    id: 'app.sml.workspaces.noLongerMember',
    defaultMessage: 'You are no longer a member of {workspace}.',
  },
  // design: workspaces a3. The toast after a switch.
  switched: { id: 'app.sml.workspaces.switched', defaultMessage: 'You are in {workspace}.' },
  tryAgain: { id: 'app.sml.workspaces.tryAgain', defaultMessage: 'Try again' },
  // design: workspaces b1. The line under the email in the account sheet: "Label plan · Nightshift Records".
  planInWorkspace: { id: 'app.sml.workspaces.planInWorkspace', defaultMessage: '{plan} · {workspace}' },
  // design: workspaces e2. The toast after a leave of the active workspace.
  left: { id: 'app.sml.workspaces.left', defaultMessage: 'You left {workspace}.' },
  // design: workspaces e2. The leave confirm of "Your workspaces".
  leaveTitle: { id: 'app.sml.workspaces.leave.title', defaultMessage: 'Leave {workspace}?' },
  leaveBody: {
    id: 'app.sml.workspaces.leave.body',
    defaultMessage:
      'You lose access to its artists, pages and campaigns right away. Your own workspace stays as it is. To come back, ask the owner for a new invite.',
  },
  leaveConfirm: { id: 'app.sml.workspaces.leave.confirm', defaultMessage: 'Leave workspace' },
  // design: workspaces e2. The body when the home workspace is known.
  leaveBodyNamed: {
    id: 'app.sml.workspaces.leave.bodyNamed',
    defaultMessage:
      'You lose access to its artists, pages and campaigns right away. {home}, your own workspace, stays as it is. To come back, ask the owner for a new invite.',
  },
  // design: workspaces e2. The workspace row in the leave confirm.
  ownedByPlan: { id: 'app.sml.workspaces.ownedByPlan', defaultMessage: 'Owned by {email} · {plan}' },
});
